import React from 'react';
import { Checkbox } from 'components/Checkbox/Checkbox';
import Text from 'components/Text/Text';

interface IProps {
	isActiveBpa: boolean;
	toggleActivateBPA: () => void;
}

export const ActivateBPACheckBox: React.FC<IProps> = React.memo(({ isActiveBpa, toggleActivateBPA }) => (
	<Checkbox checked={isActiveBpa} testId="ActivateBPACheckBox" onChange={toggleActivateBPA}>
		<Text translationNameSpace="form" translationKey="activateBPALabel" />
	</Checkbox>
));
